module.exports = require('./lib/index').default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/~/axios-retry/index.js
 ** module id = 981
 ** module chunks = 0
 **/